import {interpret} from 'xstate'

import machine from '@components/OverlayManager/overlay-manager.machine'

const interpreter = interpret(machine).start()

export default function useOverlayManagerInterpreter() {
  return interpreter
}
